import { useMemo } from "react";
import { appointmentTimeSlotPlanItemsColumns } from "../lib/constants/appointmentTimeSlotPlanItemColumns";
import { AppointmentTimeSlotPlanItem } from "@rumble-it/common-lib/types/models/AppointmentTimeSlotPlanItem.interface";
import { AppointmentTimeSlotPlanItemFormValues } from "./AppointmentTimeSlotPlanForm";
import { Table } from "@/components/v2";

const daysOrder = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const sortByDayThenStart = (a: any, b: any) => {
  const da = daysOrder.indexOf(a?.dayOfWeek);
  const db = daysOrder.indexOf(b?.dayOfWeek);
  if (da !== db) return da - db;
  return (a.startTime || "").localeCompare(b.startTime || "");
};

interface AppointmentTimeSlotPlanItemsListProps {
  items?:
    | AppointmentTimeSlotPlanItem[]
    | AppointmentTimeSlotPlanItemFormValues[];
  showActions?: boolean;
  onEdit?: (item: AppointmentTimeSlotPlanItemFormValues) => void;
  onDelete?: (item: AppointmentTimeSlotPlanItemFormValues) => void;
}

export const AppointmentTimeSlotPlanItemsList = ({
  items = [],
  showActions = true,
  onEdit,
  onDelete,
}: AppointmentTimeSlotPlanItemsListProps) => {
  const rows = useMemo(() => {
    const sorted = [...items].sort(sortByDayThenStart);
    const result: any[] = [];
    daysOrder.forEach((day) => {
      const groupItems = sorted.filter((it) => it?.dayOfWeek === day);
      if (groupItems.length === 0) return;
      result.push({ _key: `group-${day}`, __group: true, day });
      groupItems.forEach((it) => result.push(it));
    });
    return result;
  }, [items]);

  const columns = appointmentTimeSlotPlanItemsColumns({
    showActions,
    onEdit,
    onDelete,
  });

  return (
    <Table
      dataSource={rows}
      columns={columns}
      rowKey={(r) => r._key ?? r.id}
      size="small"
      pagination={false}
      rowClassName={(record) =>
        record.__group ? "bg-neutral-100 font-medium" : ""
      }
    />
  );
};

export default AppointmentTimeSlotPlanItemsList;
